import gql from 'graphql-tag';

const MUTATION_DELETE_FOLDER = gql`
	mutation DeleteFolder($slug: String!) {
		deleteFolder(slug: $slug)
	}
`;

export default MUTATION_DELETE_FOLDER;